import { TaggedFail } from '../../Fail'

export class ValidationFail extends TaggedFail('Validation') {}
